import styled from '@emotion/styled'
import { pxToRem, BREAKPOINTS } from 'utils/styled'

export const SInvisibleFileInput = styled.input`
  display: none;
`

export const SImagePickerContainer = styled.div`
  display: flex;
  min-height: ${pxToRem(210)}rem;
  & > button {
    height: fit-content;
  }
  @media ${BREAKPOINTS.XS.max} {
    flex-direction: column;
  }
`

export const SPreviewContainer = styled.div`
  height: ${pxToRem(200)}rem;
  width: ${pxToRem(200)}rem;
  & > img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`

export const SButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 1.5rem;

  @media ${BREAKPOINTS.XS.max} {
    margin-left: 0;
    margin-top: 1.5rem;
    flex-direction: row;

    & button:first-of-type {
      margin-right: 1rem;
    }
  }
`
